// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles_textarea__mpkA2","title":"styles_title__70sdv","description_title":"styles_description_title__23uHa","grid":"styles_grid__KIwJw"};